import { FloatButton, Layout } from 'antd';
import { useRef, ReactNode } from 'react';
import { StyledBackTopButtonWrapper } from 'components/styledComponents/button/Button.styled';

export interface ContentProps {
  children?: ReactNode;
  noPadding?: boolean
}

const Content = ({ children = null, noPadding = false }:ContentProps) => {
  const contentRef = useRef<HTMLElement>(null);

  return (
    <>
      <Layout.Content ref={contentRef} className={noPadding ? 'no-padding' : ''}>
        {children}
      </Layout.Content>
      <StyledBackTopButtonWrapper>
        <FloatButton.BackTop target={() => contentRef.current as HTMLElement} />
      </StyledBackTopButtonWrapper>
    </>
  );
};

export default Content;
